import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { Market } from '@/bundles/Markets/models/Market';
import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';

interface IConvertMarketOptions {
  sourceName?: string;
  category?: FilterCategoryEnum;
  titlePrefix?: string;
}

const getMarketFilterName = (marketName: string, sourceName: string = 'properties'): string => {
  return `${ sourceName }_${ marketName }_dynamic_market`.replace(/\s/i, '_').toLowerCase();
}

export const convertMarketToFilterConfig = (
  market: Market,
  selectedFilters: Record<string, any>,
  options?: IConvertMarketOptions,
): IFilterConfigItem => {
  return {
    title: options?.titlePrefix ? `${ options.titlePrefix } ${ market.name }` : market.name,
    name: getMarketFilterName(market.name, options?.sourceName),
    type: FilterTypeEnum.dynamic_market,
    category: options?.category || FilterCategoryEnum.market_location,
    additional: {
      market,
      selectedFilters
    },
  };
}
